import React, { FC, useState } from 'react';
import OfflineContext from './offline-context';
import { NewNotificationBanner } from '../../components';
import useNetworkListener from './use-network-listener';
import WifiOffInCircle from '../../icons/WifiOffInCircle';

const { Provider } = OfflineContext;

const OfflineProvider: FC = ({ children }) => {
  const [isConnectTimeOut, setIsConnectTimeout] = useState(false);

  const isOffline = useNetworkListener();
  const showOfflineMessage = isOffline || isConnectTimeOut;

  const offlineMessage = 'You appear to be offline. Please check your connection and try again.';

  return (
    <Provider
      value={{
        setIsConnectTimeout,
      }}
    >
      <NewNotificationBanner
        open={showOfflineMessage}
        variant="error"
        messages={[offlineMessage]}
        icon={<WifiOffInCircle />}
      />
      {children}
    </Provider>
  );
};

export default OfflineProvider;
